// src/user/services/api/tasks.js

import { apiRequest, buildUrl } from './index';

/**
 * Tasks API service
 * Handles all task-related API calls
 */

/**
 * Fetch workflow for a specific task
 * @param {string} accessKey - The access key for the asset
 * @param {string} taskId - The task ID
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Workflow data
 */
export async function fetchTaskWorkflow(accessKey, taskId, { signal } = {}) {
  const url = buildUrl(`/v1/assets/access_key/${encodeURIComponent(accessKey)}/tasks/${encodeURIComponent(taskId)}/workflow.json`);
  return apiRequest(url, { signal });
}

/**
 * Start a task
 * @param {string} accessKey - The access key for the asset
 * @param {string} taskId - The task ID
 * @param {Object} data - The data to send (field_engineer_id)
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Response data
 */
export async function startTask(accessKey, taskId, data, { signal } = {}) {
  const url = buildUrl(`/v1/assets/access_key/${encodeURIComponent(accessKey)}/tasks/${encodeURIComponent(taskId)}/start`);
  return apiRequest(url, {
    method: 'POST',
    body: data,
    signal,
  });
}

/**
 * Close a task with work reports
 * @param {string} accessKey - The access key for the asset
 * @param {string} taskId - The task ID
 * @param {Object} data - The data to send (work_reports, field_engineer_id)
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Response data
 */
export async function closeTask(accessKey, taskId, data, { signal } = {}) {
  const url = buildUrl(`/v1/assets/access_key/${encodeURIComponent(accessKey)}/tasks/${encodeURIComponent(taskId)}/close`);
  return apiRequest(url, {
    method: 'POST',
    body: data,
    signal,
  });
}

/**
 * Self-start a workflow task
 * @param {string} accessKey - The access key for the asset
 * @param {Object} data - The data to send (workflow_id, field_engineer_id)
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Task data
 */
export async function selfStartTask(accessKey, data, { signal } = {}) {
  const url = buildUrl(`/v1/assets/access_key/${encodeURIComponent(accessKey)}/self_start_task`);
  return apiRequest(url, {
    method: 'POST',
    body: data,
    signal,
  });
}
